
module dg.lists {

    class ShowAllController implements ng.IController {

        private queryManipulator: dg.actions.ServerQueryManipulator;

        $onInit() {

        }

        public showAll () {
            this.queryManipulator.resetQuery();
            this.queryManipulator.resetPaging();
            this.queryManipulator.executeQuery();
        }
    }

    angular.module('dg.lists').component('showAll', {
        bindings: {
            queryManipulator: '<'
        },
        controller: ShowAllController,
        templateUrl: '/digmo/src/lists/show-all.html'
    });
}